import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { BehaviorSubject, debounceTime, delay, map, Observable, Subject, switchMap, take, tap } from 'rxjs';
import { MongoDbService } from '@core/services/api/mongodb.service';
import { environment } from 'environments/environment';


@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss'],
})
export class NavMenuComponent implements OnInit {

  public search: string;
  private isText = false;
  private timeout: any = null

  // searchText = new Subject<string>();
  results: Observable<any>
  notFound = false;
  loading = false;
  dataLoaded = false;
  navigatingDropdown: boolean = false;
  initialSearchText: string | null = null;

  searchText: BehaviorSubject<string> = new BehaviorSubject<string>('');
  searchTermValue: string;
  selectedOption: any; // Property to hold the selected option

  @Input() searchParam = '';
  @Input() brands;
  @Input() categories;
  @Input() viewport
  @Input() decorations;
  
  @Output() menuOption = new EventEmitter();
  
  readonly inputSearch = new UntypedFormControl('')
  searchValue: string;
  userInput: string;

  constructor(
    private router: Router,
    private http: HttpClient,
    private _mongo: MongoDbService,
    private cdr: ChangeDetectorRef
  ) { 
      this.searchText.pipe(take(1)).subscribe(value => {
        this.searchTermValue = value

      });
  }

  ngOnInit(): void {
    this.search = this.searchParam
    if(this.categories){
      this.categories = this.categories.filter((item) => item !== 'bags')
      let data = Array.of(this.categories)
    }
  }

  onSearchInputChange(value: string) {
      this.userInput = value;

      this.results = this.searchText.pipe(
        debounceTime(250),
        switchMap((value: any) => {
          const name = typeof value === 'string' ? value : '';
          return this.filter(name)
        }),
        tap((results: any) =>
          results && results.length > 0 ? (this.notFound = false) : (this.notFound = true)
        )
      );

      this.searchText.next(value);
  }

  searchTerm() {
    this.searchText.pipe(take(1)).subscribe(value => {
      this.filterNavbar('search', value)

    });
  }

  filter(value: string): any {
    this.navigatingDropdown = false; //reset navigation flag

    const filterValue = value.toLowerCase();
    if(!this.navigatingDropdown) {
      const url = `${environment.apiMicroservice}products/search?search=${encodeURI(filterValue)}&page=1&pageSize=10`;
  
      this.userInput = value;
      this.loading = true;
      this.cdr.detectChanges(); // Trigger change detection

  
      return this.http.get(url).pipe(
        map((data: any) => {
          return data.products
        }),
        delay(300),
        tap(() => (
          this.loading = false,
          this.cdr.detectChanges() // Trigger change detection again after loading is false
        ))
      );
    }
  }

  displayValue(value: any): string {
    return value ? value : '';
  }

  onOpen(): void {
    if (!this.dataLoaded) {
      this.searchText.next('');
      this.userInput = null
      this.selectedOption = null; // Clear the selected option when autocomplete is opened
      this.dataLoaded = true;
    }
  }

  // Function to handle image URLs based on the vendor
  getVendorImageUrl(option: any): string {
    const defaultUrl = 'https://img.stokkup.com/app/no-image.png';
    const vendorBaseUrls = {
        'ssactivewear': 'https://cdn.ssactivewear.com/',
        'alphabroder': 'https://www.alphabroder.com/prodimg/large/',
        'sanmar': '',
        'AS Colour': ''
    };

    let baseUrl = defaultUrl;

    if (option && option.vendor) {
        for (const vendor in vendorBaseUrls) {
            if (option.vendor.includes(vendor)) {
                baseUrl = vendorBaseUrls[vendor];
                break;
            }
        }
        if (option.customProduct && option.customProduct === true) {
            baseUrl = '';
        }
    } else {
      baseUrl = '';
    }

    return baseUrl + (option?.images[0] || ''); // Append the image name to the base URL
  }

  // Function to handle image URLs based on the vendor
  getVendorImageUrl2(option: any): string {
    // let baseUrl = 'https://img.stokkup.com/app/no-image.png'; // Default URL for images
    let baseUrl = option

    if (option) {
      if (option.includes('ssactivewear')) {
        baseUrl = option.replace('/Images/Style', ''); // Remove "/Images/Style"
      }
    }

    return baseUrl
  }
    
  goToProduct(option: any) {
    if(option.brand && option.style) {
      const url = `/catalog/${encodeURIComponent(option.brand.trim())}/${option.style.trim()}`;
      location.href = url;
    }
  }

  goToProductOption(option: any) {
    this.selectedOption = option; // Capture the selected option

    const [brand, title] = option.option.value.split('-');

    if(this.navigatingDropdown) {
      if(brand && title) {
        const url = `/catalog/${encodeURIComponent(brand.trim())}/${title.trim()}`;
        location.href = url;
      } else {
        this.filterNavbar('search', this.userInput)
      }
    }
   
 
   }
  

  onChange(event){
    if(event.target.value){
      this.isText = true
    }else {
      this.isText = false
    }
    
    let value = event.target.value
    this.search = value
    this.userInput = value

    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      if(this.navigatingDropdown && event.keyCode == 13) {
        let searchQueryObj = {
          search : this.search
        }
        this.goToProduct(searchQueryObj)
      }
      else if(event.keyCode == 13){
        this.filterNavbar('search', this.search ? this.search : this.userInput) // event emitter to hit api
      }
    }, 1500)
  }

  filterNavbar(key: string, item: string){
    this.search = !key ? '' : this.search
    
    let option = {key, item}
    if((!key && !item) || (key == 'search' && !item)) {
      this.router.navigate(['catalog/'])    
    } else {
      this.menuOption.emit(option);
    }
  }

  onKeyDown(event: KeyboardEvent) {
    // Detect arrow keys (Up: 38, Down: 40)
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      this.navigatingDropdown = true;
    } 
  }
  

  clear(){
    this.isText = false
    this.search = '';
    this.filterNavbar('', this.search)
  }

}
